import React, { useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { authServiceFactory } from 'src/business/service/auth-service';
import { LoginGenericBanner } from 'src/component/auth/login-generic-banner';
import style from 'src/screen/reset-password/reset-password.module.scss';

type FormValues = { email: string };

export const ResetPassword = (): React.ReactElement => {
	const {
		register,
		setValue,
		handleSubmit,
		setError,
		formState: { errors, isValid },
	} = useForm({ mode: 'onChange' });
	const [isLoading, setIsLoading] = useState(false);
	const [successful, setSuccessful] = useState(false);

	const handleResetPassword = async (data: FormValues): Promise<void> => {
		setIsLoading(true);
		const email = data.email;
		try {
			await authServiceFactory().resetPassword({ email });
			setSuccessful(true);
			setValue('email', '');
		} catch (e) {
			setSuccessful(false);
			setError('email', { type: 'focus', message: "Email doesn't exist" }, { shouldFocus: true });
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<>
			<Container fluid={true}>
				<Row className="signup-background-color">
					<LoginGenericBanner />
					<Col
						xs={6}
						md={4}
						className="gap-3 d-flex flex-column align-items-center"
					>
						{!successful && (
							<div
								className={`${style.form} d-flex align-items-center justify-content-center flex-column pt-5`}
							>
								<h1 className="d-flex align-items-center justify-content-center margin-top pt-5">
									<b>Reset Password</b>
								</h1>
								<Form
									onSubmit={handleSubmit(handleResetPassword)}
									className="w-100"
								>
									<Form.Group className="form-group pt-5">
										<Form.Label>Email</Form.Label>
										<Form.Control
											type="text"
											className="border-0"
											isInvalid={!!errors.email}
											required={true}
											{...register('email', {
												required: 'You must specify an email address',
												pattern: {
													value: /\S+@\S+\.\S+/,
													message: 'Entered value does not match email format',
												},
											})}
										/>
										<Form.Control.Feedback type="invalid">
											{errors.email && <p>{errors.email.message}</p>}
										</Form.Control.Feedback>
									</Form.Group>
									<Form.Group className="d-flex align-items-center justify-content-end">
										<Button
											className={`${style.btn} btn-lg btn-primary continue-button`}
											type="submit"
											disabled={isLoading || !isValid}
										>
											Reset Password
										</Button>
									</Form.Group>
								</Form>
							</div>
						)}
						{successful && (
							<div
								className={`${style.form} d-flex align-items-center justify-content-center flex-column pt-5`}
							>
								<h1 className="d-flex align-items-center justify-content-center margin-top pt-5">
									<b>Successful. Check your email.</b>
								</h1>
							</div>
						)}
					</Col>
				</Row>
			</Container>
		</>
	);
};
